export default "__VITE_ASSET__92af526f__"